import React from 'react';
import theme from './../theme';

import {Table, TableHead, TableBody, TableCell, TableRow, Checkbox, Icon} from '@material-ui/core';
import {IconButton} from '@material-ui/core'

import {CheckBox, MoreVert} from '@material-ui/icons'
import CheckBoxOutlineBlankIcon from '@material-ui/icons/CheckBoxOutlineBlank'
import { Fragment } from 'react';
import { getIndexByID, getObjectByID } from '../api/helpers';

import ArrowUpwardIcon from '@material-ui/icons/ArrowUpward';
import ArrowDownwardIcon from '@material-ui/icons/ArrowDownward';

export class SortableTable extends React.Component {

    constructor(props){
        super(props)

        let  refs = this.props.columns.map(column=>({
            name: column.name, 
            cellRef: React.createRef(),
            spanRef: React.createRef()
        }))

        this.state = {
            menuAnchor: null,
            selectCheckBox: false,
            sort: [],
            rows: this.props.rows,
            columnRefs: refs
        }

        this.handleSelectionClick = this.handleSelectionClick.bind(this)
        this.handleSelectionAllClick = this.handleSelectionAllClick.bind(this)

        this.handleRowClick = this.handleRowClick.bind(this)
        this.handleRowDoubleClick = this.handleRowDoubleClick.bind(this)
        this.handleHeadClick = this.handleHeadClick.bind(this) 
    }

    componentDidUpdate(prevProps){

        //alert('componentDidUpdate' + this.props.version  + ' '+prevProps.version)

        if(this.props.version !== prevProps.version){
            //alert('data changed')


            this.setState({
                menuAnchor: null,
                selectCheckBox: false,
                rows: this.props.rows
            })
        }
    }

    handleMenuClick(event, itemID){
        this.setState({menuAnchor: event.currentTarget, menuItemID: itemID});

        if(this.props.onMenuClick){
            this.props.onMenuClick(itemID)
        }
        
        event.stopPropagation();
    }

    handleMenuClose(){
        this.menuAnchor = null;
        this.setState({menuAnchor: null});
        return null;
    }

    /*
    getRowStyle(index){
        //let selected = euuid === this.props.selectedItemID
        let isOdd = index % 2

        let style = {
            background: (isOdd ? theme.palette.background.oddRow : ''),
            cursor: 'pointer'
        }
        return style
    }
    */

    getSelectedRows(){
        ///alert('getSelectedRows')

        let rows = this.state.rows.filter((row)=>{return row.selected})

        rows = rows.map(item => ({...item, selected: false}) )

        return rows
    }

    handleSelectionAllClick(event){

        let rows = this.selectAll(event.target.checked)

        this.setState({
            selectCheckBox: event.target.checked,
            rows: rows
        })  

    }

    handleSelectionClick(event){
        let row = this.state.rows[event.target.value]
        row.selected = event.target.checked

        let selectCheckBox =  event.target.checked || this.getSelectedRows().length > 0 ? true : false

        this.setState({rows: this.state.rows, selectCheckBox: selectCheckBox})
    }

    selectAll(selected){
        console.log('selectAll')
        console.log(this.state.rows)

        let rows = this.state.rows.map((item, index)=>{
            item.selected = selected
            return item
        })

        console.log(rows)

        return rows
    }

    getRowStyle(row, index){
        let selected = row.selected
        let isOdd = index % 2

        let style = {
            background: selected ? 
                        theme.palette.background.selectedRow 
                        : 
                        (isOdd ? theme.palette.background.oddRow : ''),
            cursor: 'pointer'
        }
        return style
    }

    handleRowClick(row, index){
        if(this.props.onRowClick){
            this.props.onRowClick(row, index)
        }
    }

    handleRowDoubleClick(row, index){
        if(this.props.onRowDoubleClick){
            this.props.onRowDoubleClick(row, index)
        }
    }

    applySort(sort){
        let result = 0


        let sortFunction = (a, b)=>{

            for (let i in sort){

                let name = sort[i].name
                let column = getObjectByID(name, this.props.columns, 'name')  
                let order = sort[i].order

                if(!column){
                    console.log('name')
                    console.log(name)
                    console.log('column')
                    console.log(column)
                    console.log('this.props.columns')
                    console.log(this.props.columns)
                    console.log('order')
                    console.log(order)
                    console.log('column not found '+name)
                }

                let valA, valB
                if(column.sortEval!==undefined){
                    valA = column.sortEval(a[name], a)
                    valB = column.sortEval(b[name], b)
                }else{
                    valA = a[name]
                    valB = b[name]
                }

                if(valA === valB) continue

                if(order==='asc'){
                    return valA > valB ? 1 : -1
                }else if (order==='desc'){
                    return valA < valB ? 1 : -1
                }

            }

            return result
        }


        this.state.rows.sort(sortFunction)

    }

    handleHeadClick(column){
        //alert(column.name)

        if(column.allowSort===undefined || !column.allowSort ) return


        let sort = this.state.sort

        console.log('handleHeadClick sort: '+column.name+', sort:')
        console.log(sort)

        let currentSort = getObjectByID(column.name, sort, 'name')
        let newSort

        //console.log('currentSort')
        //console.log(currentSort)

        if(currentSort){
            switch(currentSort.order){
                case 'none': newSort='asc'; break
                case 'asc': newSort='desc'; break
                case 'desc': newSort=null; break
            }
        }else{
            newSort='asc'
        }

        let index = getIndexByID(column.name, sort, 'name')
        //console.log('index '+column.name)
        //console.log(index)
        //console.log('newSort')
        //console.log(newSort)

        if(newSort==null){
            //delete sort
            if(index!==null) sort.splice(index, 1)
        }else{
            if(index!==null){
                sort[index] = {name: column.name, order: newSort}
            }else{
                sort.push({name: column.name, order: newSort} )
            }
        }

        //console.log('set sort')
        //console.log(sort)
        this.setState({sort: sort})

        this.applySort(sort)
    }

    getSize(ref){
        if(ref.current){
            return {
                width: ref.current.clientWidth,
                height: ref.current.clientHeight
            }
        }else{
            return null
        }
    }

    sortButton(column){

        let cellRef = this.getColumnRef(column.name, 'cellRef')
        let spanRef = this.getColumnRef(column.name, 'spanRef')
        //console.log('cellRef')
        //console.log(cellRef)

        let cellSize = this.getSize(cellRef)
        let spanSize = this.getSize(spanRef)

        //console.log(cellSize)
        //console.log(spanSize)

        let top = 10
        let left = 50
        if(cellSize && spanSize){
            top = cellSize.height/2 - 10
            left = spanSize.width + 1
            if(left+10>cellSize.width) left = cellSize.width - 30
        }

        let currentSort = ''
        let index = getIndexByID(column.name, this.state.sort, 'name')
        //console.log('sortButton '+ column.name +' index '+index)
        if(index!==null){
            let columnSort = this.state.sort[index]
            //console.log('columnSort')
            //console.log(columnSort)
            currentSort = columnSort.order
        }

        switch (currentSort){
            case 'asc': return (
                <ArrowUpwardIcon fontSize="small" 
                    style={{marginLeft: 5, position: 'absolute', top: top, left: left}}/>
                )
            case 'desc': return (
                <ArrowDownwardIcon fontSize="small" 
                    style={{marginLeft: 5, position: 'absolute', top: top, left: left}}/>
            )
            default: return (
                <Icon fontSize="small" width={20} height={20} 
                    style={{display: 'inline-block', marginLeft: 5, align: 'absmiddle', position: 'absolute', top: top, left: left}}/>)
        }

    }

    getColumnRef(name, prop){
        let columnRef = getObjectByID(name, this.state.columnRefs,'name')
        return columnRef ? columnRef[prop] : null
    }

    renderTableHead(){

        const styles = {
            head: {
                color: theme.palette.color.dialogTitle,
                backgroundColor: theme.palette.background.dialogTitle,
            }
        }

        return (
            <TableHead>
                <TableRow>

                    {this.props.checkboxSelection?(
                        <TableCell style={{...styles.head, width: 30}}>
                            <Checkbox 
                                checked={this.state.selectCheckBox}
                                onChange={this.handleSelectionAllClick}
                                icon={<CheckBoxOutlineBlankIcon style={{color: "white"}} />}
                                checkedIcon={<CheckBox style={{color: "white"}} />}
                            />
                        </TableCell>
                    ) : null}

                    {/*align='absmiddle'*/}
                    {this.props.columns.map((column,index)=>(
                        <TableCell key={index} 
                            ref={this.getColumnRef(column.name, 'cellRef')}
                            style={{...styles.head, position: 'relative', cursor: column.allowSort?'pointer':'default'}} 
                            onClick={()=>this.handleHeadClick(column)}>

                            <span ref={this.getColumnRef(column.name, 'spanRef')}
                                style={{display: 'inline-block', padding: '10px 0'}}>{column.label}</span>

                            {column.allowSort ? (this.sortButton(column)) : null}
                        </TableCell>
                    )) }

                    {this.props.contextMenu? <TableCell style={styles.head}></TableCell> : null}
                </TableRow>
            </TableHead>
        )

    }


    renderTableBody(){

        console.log('renderTableBody')
        console.log(this.state.rows)

        return(

            <TableBody>
                {this.state.rows && this.state.rows.map((row,index)=>(
                    <Fragment key={index}>
                    { this.renderTableRow(row, index)}
                    </Fragment>
                ))}
            </TableBody>

        )
    }

    renderTableRow(row, index){

        if(row===undefined){
            console.log('empty row')
            console.log(row)
            return ''
        }

        return(<TableRow key={index} 
                style={this.getRowStyle(row, index)}
                onClick={()=>{this.handleRowClick(row, index)}}
                onDoubleClick={()=>{this.handleRowDoubleClick(row, index)}}
                >

                {this.props.checkboxSelection?(<TableCell>
                    <Checkbox 
                        value={index}
                        checked={row.selected!==undefined ? row.selected : false}
                        onChange={this.handleSelectionClick} />
                </TableCell>) : null}

                {this.props.columns.map((column,index)=>(<TableCell key={index}>
                        
                        {column.eval ?
                        column.eval(row[column.name], row)
                        : row[column.name]
                        }
                    
                </TableCell>))}

                {this.props.contextMenu? (<TableCell style={{width: 40}}>
                    <IconButton size="small" color="inherit" aria-label="add" component="span"
                        onClick={event=>this.props.onMenuClick(event, row.euuid)}>
                        <MoreVert />
                    </IconButton>
                </TableCell>) : null}

        </TableRow>)
    }

    render(){

        console.log(this.props)

        return(<Table size="small">
                    
            {this.renderTableHead()}

            {this.renderTableBody()}

            {this.props.contextMenu ? (<>{this.props.contextMenu}</>) : null}

        </Table>)

    }
}

///export const SortableTable = withTranslation()(SortableTable_);